// extracted by mini-css-extract-plugin
export default {"header-content":"style_header-content__ySqSR","headerContent":"style_header-content__ySqSR","content":"style_content__UU9t2"};